import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../constants/common'
import { getItemsIds } from '../../utils/common'
import { getServerErrorNotificationKey } from '../../utils/validation'

import {
  TaskActivityApiNames,
  TaskStatusType,
  TaskTableItemCommitType,
} from './Task.enums'

import BriefcaseIcon from '../../icons/activities/briefcase.svg'
import CalendarIcon from '../../icons/activities/calendar.svg'
import CameraIcon from '../../icons/activities/camera.svg'
import CarIcon from '../../icons/activities/car.svg'
import CaseIcon from '../../icons/activities/case.svg'
import ChartLineIcon from '../../icons/activities/chart-1.svg'
import ChartPieIcon from '../../icons/activities/chart-2.svg'
import ChimneyIcon from '../../icons/activities/chimney.svg'
import ClockIcon from '../../icons/activities/clock.svg'
import ComputerIcon from '../../icons/activities/computer.svg'
import DialogIcon from '../../icons/activities/dialog.svg'
import DocumentSearchIcon from '../../icons/activities/document-search.svg'
import GlobeIcon from '../../icons/activities/globe.svg'
import HourglassIcon from '../../icons/activities/hourglass.svg'
import KeyIcon from '../../icons/activities/key.svg'
import LaptopChartIcon from '../../icons/activities/laptop-chart.svg'
import LaptopSimpleIcon from '../../icons/activities/laptop-simple.svg'
import LightbulbIcon from '../../icons/activities/lightbulb.svg'
import ListIcon from '../../icons/activities/list.svg'
import LocationIcon from '../../icons/activities/location.svg'
import MoneyIcon from '../../icons/activities/money.svg'
import PhotoAndTextIcon from '../../icons/activities/photo-and-text.svg'
import PlantIcon from '../../icons/activities/plant.svg'
import PresentationIcon from '../../icons/activities/presentation.svg'
import ProtectionIcon from '../../icons/activities/protection.svg'
import SmartphoneIcon from '../../icons/activities/smartphone.svg'
import SpeakerIcon from '../../icons/activities/speaker.svg'
import UmbrellaIcon from '../../icons/activities/umbrella.svg'
import DocumentIcon from '../../icons/document.svg'
import EditIcon from '../../icons/edit.svg'
import EmailIcon from '../../icons/email.svg'
import PhoneIcon from '../../icons/phone.svg'
import PrintIcon from '../../icons/print.svg'
import WorkerIcon from '../../icons/provider.svg'
import SettingsIcon from '../../icons/settings.svg'
import TaskIcon from '../../icons/task.svg'
import UsersIcon from '../../icons/users-1.svg'
import WorkIcon from '../../icons/work.svg'

export function isTaskDone(item) {
  return item.done || item.yesno !== null
}

export function getTaskIconByApiName(name) {
  switch (name) {
    case TaskActivityApiNames.Call1:
      return SmartphoneIcon
    case TaskActivityApiNames.Call2:
      return PhoneIcon
    case TaskActivityApiNames.Camera:
      return CameraIcon
    case TaskActivityApiNames.Car:
      return CarIcon
    case TaskActivityApiNames.Cash:
      return MoneyIcon
    case TaskActivityApiNames.Chart:
      return ChartLineIcon
    case TaskActivityApiNames.Chimney:
      return ChimneyIcon
    case TaskActivityApiNames.Craftsman1:
      return CaseIcon
    case TaskActivityApiNames.Craftsman2:
      return WorkerIcon
    case TaskActivityApiNames.Deadline1:
      return HourglassIcon
    case TaskActivityApiNames.Deadline2:
      return CalendarIcon
    case TaskActivityApiNames.Deadline3:
      return ClockIcon
    case TaskActivityApiNames.Email:
      return EmailIcon
    case TaskActivityApiNames.Gardening:
      return PlantIcon
    case TaskActivityApiNames.Insuranse:
      return ProtectionIcon
    case TaskActivityApiNames.Jourfix:
      return LightbulbIcon
    case TaskActivityApiNames.KeyDelivery:
      return KeyIcon
    case TaskActivityApiNames.Laptop:
      return LaptopSimpleIcon
    case TaskActivityApiNames.Location:
      return LocationIcon
    case TaskActivityApiNames.Meeting1:
      return BriefcaseIcon
    case TaskActivityApiNames.Meeting2:
      return UsersIcon
    case TaskActivityApiNames.PieChart:
      return ChartPieIcon
    case TaskActivityApiNames.Posting1:
      return PhotoAndTextIcon
    case TaskActivityApiNames.Posting2:
      return SpeakerIcon
    case TaskActivityApiNames.Print:
      return PrintIcon
    case TaskActivityApiNames.Reporting1:
      return DocumentIcon
    case TaskActivityApiNames.Reporting2:
      return LaptopChartIcon
    case TaskActivityApiNames.Request:
      return PresentationIcon
    case TaskActivityApiNames.Research1:
      return GlobeIcon
    case TaskActivityApiNames.Research2:
      return DocumentSearchIcon
    case TaskActivityApiNames.Talk:
      return DialogIcon
    case TaskActivityApiNames.Task:
      return ListIcon
    case TaskActivityApiNames.Tool:
      return WorkIcon
    case TaskActivityApiNames.Tv:
      return ComputerIcon
    case TaskActivityApiNames.Vacation:
      return UmbrellaIcon
    case TaskActivityApiNames.Work:
      return SettingsIcon
    case TaskActivityApiNames.Writing:
      return EditIcon

    default:
      return TaskIcon
  }
}

export function getEmailThreadsFromResponse(data) {
  return { items: data.results.objects }
}

export function getAttachedEmailThreads(data) {
  return data.results.objects
}

export function isTaskYesNoCommitType(value) {
  return value.commit_type === TaskTableItemCommitType.YesNo
}

export function isTaskDoneCommitType(value) {
  return value.commit_type === TaskTableItemCommitType.Done
}

export function isTaskStatusTypeNo(type) {
  return type === TaskStatusType.No
}

export function isTaskStatusTypeYes(type) {
  return type === TaskStatusType.Yes
}

export function getAllEmailThreadsFromResponse(data) {
  return data.results.objects
}

export function getTaskNextFileIds(currentFiles, newFiles) {
  const ids = getItemsIds([...(currentFiles ?? EMPTY_LIST), ...newFiles])

  return Array.from(new Set(ids))
}

export function getTaskUpdateErrorNotificationKey(error, fallbackKey) {
  return getServerErrorNotificationKey(error?.response?.data, fallbackKey)
}

export function getTaskCreationSuccessNotificationProps({ request, t, title }) {
  return {
    text: t('Notification.TaskCreatedText', {
      request_number: request.request_no,
      request_title: request.title,
      title,
    }),
    title: t('Notification.TaskCreatedTitle'),
    // #TODO Uncomment after request profile realization
    // linkProps: {
    //   title: t('Notification.TaskCreatedViewRequestLinkKey'),
    //   to: `/request/${id}`,
    // },
    type: NOTIFICATION_TYPE.success,
  }
}
